import type { IDBPDatabase } from "idb";

export default abstract class CacheModule<K extends IDBValidKey, V> {

    protected storeName: string;
    protected cache: IDBPDatabase;

    constructor(sn: string, c: IDBPDatabase) {
        this.storeName = sn;
        this.cache = c;
    }

    async getValue(k: K): Promise<V | undefined> {
        return await this.cache.get(this.storeName, k)
    }

    async getAll(): Promise<V[]> {
        return await this.cache.getAll(this.storeName) || []
    }
    
    async saveValue(k: K, v: V): Promise<IDBValidKey | IDBKeyRange | undefined> {
        return await this.cache.put(this.storeName, v, k)
    }
}
